// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"5e4f26193c572ac75b79","264":"59ed789822f77b818b20","265":"dfda66b4ef36aa753f20","318":"54c4e9c298e66a696878"}[chunkId] + ".chunk.js";
};